import { useEffect, useRef } from "react";
import { CMSBanner, type CMSBannerProps } from "./CMSBanner";
import { Carousel, type CarouselRefAttributes } from "../../common/components/carousel/Carousel";
import type ComponentTypes from "../componentTypes";
import classNames from "classnames";

export interface CMSRotatingBannersProps {
  type: ComponentTypes.CMSRotatingBanners;
  /**
   * Time in milliseconds when the slide should change
   */
  timeout?: number;
  /**
   * A valid CMSBanner properties object
   */
  banners: CMSBannerProps[];
  className?: string;
}

export const CMSRotatingBanners = ({ banners, timeout = 0, className }: CMSRotatingBannersProps) => {
  const carouselRef = useRef<CarouselRefAttributes>(null);

  const pageAmount = banners.length;

  useEffect(() => {
    if (pageAmount > 1) {
      const intervalId = setInterval(() => {
        if (carouselRef.current) {
          carouselRef.current.setNextPage();
        }
      }, timeout);
      return () => clearInterval(intervalId);
    }
  }, [timeout, pageAmount]);

  return (
    <Carousel
      className={classNames("scha__rotating-banners", className)}
      data={banners}
      pageItemsCount={1}
      renderSlide={(data) => {
        const banner = data.data[0];

        return <CMSBanner {...banner} />;
      }}
      ref={carouselRef}
      continuous={true}
    />
  );
};
